module.exports = __webpack_public_path__ + "static/media/tooltip-info.0b27a75e.svg";